<script>
export default {
  name: 'UlFormInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    elInput() {
      return this.$refs.input;
    },
  },
  methods: {
    input(e) {
      this.$emit('input', e.target.value);
    },
    change(e) {
      this.$emit('change', e.target.value);
    },
  },
};
</script>
<template>
  <input
    ref="input"
    :type="type"
    class="ul-form-input"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="input"
    @change="change"
    @keypress.enter="$emit('submit', $event)"
  >
</template>
<style lang="scss">
  .ul-form-input {
    border: none;
    font-size: 16px;
    width: 100%;
    outline: none;
    background: none;
    position: relative;
    height: 28px;
    display: block;
    padding: 0;
    color: #333333;

    &::placeholder {
      font-weight: 300;
    }
  }
</style>
